export const SITE = {
  name: "Dra. Luísa Azevedo Lopes",
  shortName: "Luísa Azevedo Lopes",
  email: "luisalopes-72617p@adv.oa.pt",
  phone: "+351 933 387 472",
  offices: "Vila Verde",
  linkedin: "https://www.linkedin.com/in/luisa-lopes0016",
  instagram: "https://www.instagram.com/luisalopes.advogada/",
  facebook: "https://www.facebook.com/profile.php?id=61594985098397",
};

export const CATEGORIES = [
  "Todos",
  "Legislação UE",
  "Jurisprudência",
  "Fauna Selvagem",
  "Animais de Companhia",
  "Artigos Académicos",
];

export const ARTICLE_CATEGORIES = CATEGORIES.slice(1);

export const IMAGES = {
  portrait: "/images/retrato.webp",
  portraitAlt: "/images/retrato.webp",
  library:
    "https://images.unsplash.com/photo-1669348849154-25e23e2ccf05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxsYXclMjBib29rc3xlbnwwfHx8fDE3ODgyODA3ODJ8MA&ixlib=rb-4.1.0&q=85",
  forest:
    "https://images.unsplash.com/photo-1625673016962-05a04c4c2432?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxuYXR1cmUlMjBmb3Jlc3R8ZW58MHx8fHwxNzg5MTM4MTkzfDA&ixlib=rb-4.1.0&q=85",
};
